import React, { createContext, useContext } from 'react';

interface VoiceContextType {
    isListening: boolean;
    transcript: string;
    spokenAnswer: string;
    finalSpokenAnswer: string;
    recognitionStatus: string;
    isRecognizerRunning: boolean;
    startListening: (emoji?: string) => void;
    stopListening: (emoji?: string) => void;
    toggleListening: () => void;
    registerCommands: (commands: string[]) => void;
    voiceCommand: string; // Added voiceCommand to the context
    clearVoiceCommand: () => void;  
    clearSpokenAnswer: () => void;
    speakMessage: (message: string) => void;
    speechRecognitionSupported: () => boolean;
    questionTypesIncompatibleWithVoiceMode: string[]
    microphonePermission: string | null;
    registeredCommands: string[]
    isListeningEnabled: boolean
    setIsListeningEnabled: (enabled: boolean) => void
}

const VoiceContext = createContext<VoiceContextType | null>(null);

export const useVoice = () => {
    const context = useContext(VoiceContext);
    if (context === null) throw new Error("useVoice must be used within a VoiceProvider");
    return context;
};

export default VoiceContext;